// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Agents extends APIResource {
    /**
     * Creates an Agent or multiple Agents from a template
     */
    create(templateVersion, body = {}, options) {
        return this._client.post(path `/v1/templates/${templateVersion}/agents`, { body, ...options });
    }
}
//# sourceMappingURL=agents.mjs.map